import { pr, ui } from "aaa";
import { SettingsButton } from "components/loginManagement/components/SettingsButton";
import { themeColors } from "muiTheme";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { IJuniorDocumentLinks } from "types/profile";
import { safeWindowOpen } from "util/helpers";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";

type DocumentItemProps = {
    displayName: string;
    _links: IJuniorDocumentLinks;
    store: JuniorStore;
};

export const DocumentItem = ({ displayName, _links, store }: DocumentItemProps) => {
    const handleClick = async () => {
        if (_links.documentExternal?.href) {
            safeWindowOpen(_links.documentExternal.href, "_blank");
            return;
        }

        if (_links.documentDownload?.href) {
            try {
                await store.loadPdfFromUrl(_links.documentDownload.href);
                pushRoute(JuniorRoutes.PDF);
            } catch (error) {
                console.error("Error loading PDF:", error);
                pushRoute("/error");
            }
        }
    };

    return (
        <SettingsButton
            border="none"
            borderRadius="both"
            onClick={handleClick}
            style={{ backgroundColor: ui.isDarkMode ? themeColors.d_grey_300 : "white" }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <img src={require("../../../assets/gJunior/document_icon.svg")} alt="document" />
                    <pr.P_16_CONTENT style={{
                        color: ui.isDarkMode ? "white" : themeColors.george_text_color,
                        fontWeight: 500,
                    }}>
                        {displayName}
                    </pr.P_16_CONTENT>
                </div>
                <pr.IconChevronRight style={{ color: "#A7B6C7" }} />
            </div>
        </SettingsButton>
    );
};


// WEBPACK FOOTER //
// ./src/components/gJunior/components/DocumentItem.tsx